import {
  imageBackground,
  imageAutoplayEnabled,
  imageMute,
} from 'src/tools/contentModulesFieldName';
import { get } from 'lodash';
import { useState, useEffect } from 'react';
import { layers as lK } from 'src/tools/contentModulesFieldName';
import { generateResponsiveImageLayer } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/generator';
import arrayMove from 'array-move';
import { validateLayerType } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import { msg } from 'src/tools/message';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const handleOnChange = (value, form) => {
  if (get(value, imageBackground)) {
    form.setFieldsValue({
      [imageAutoplayEnabled]: true,
      [imageMute]: true,
    });
  }
};
const useLayers = ({ layerForm, editForm, data, onConfirm, breakpoint }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [selectedLayer, setSelectedLayer] = useState(null);
  useEffect(() => {
    editForm.setFieldsValue(data);
    const firstLayer = get(data, `layers.0`);
    if (firstLayer) {
      handleOnLayerClick(firstLayer);
    }
  }, []);

  const handleOnLayerAdd = (value, onChange) => {
    const nLayer = generateResponsiveImageLayer();
    const nV = [...(value || []), nLayer];
    if ((value || []).length === 0) {
      onChange(nV);
      handleOnLayerClick(nLayer);
    } else {
      onChange(nV);
    }
  };

  const handleOnLayerReorder = (value, onChange, from, to) => {
    const nV = arrayMove(value || [], from, to);
    onChange(nV);
  };

  const handleOnLayerDelete = (value, onChange, index) => {
    const nV = (value || []).filter((_, i) => {
      return i !== index;
    });
    const deleteDraggableId = get(get(value, index), 'draggableId');
    //const cIndex = (value || []).find(i=>i.);
    if (deleteDraggableId === selectedLayer) {
      if (nV.length === 0) {
        setSelectedLayer(null);
        layerForm.resetFields();
      } else {
        const nId = get(get(nV, 0), 'draggableId');
        setSelectedLayer(nId);
      }
    }

    onChange(nV);
  };

  const handleOnLayerClick = (layer) => {
    const handleOnSetNewSelected = () => {
      const draggableId = get(layer, 'draggableId');
      setSelectedLayer(draggableId);

      if (layerForm) {
        layerForm.resetFields();
        layerForm.setFieldsValue(layer);
      }
    };
    if (selectedLayer) {
      // layerForm.validateFields().then((values) => {
      //   const layers = editForm.getFieldValue(lK);
      //   const nDataLayers = layers.map((layer) => {
      //     const draggableId = get(layer, 'draggableId');
      //     if (draggableId === selectedLayer) {
      //       return { ...(layer || {}), ...(values || {}) };
      //     } else {
      //       return layer;
      //     }
      //   });
      //   editForm.setFieldsValue({ [lK]: nDataLayers });
      //   handleOnSetNewSelected();
      // });
      const values = layerForm.getFieldsValue();
      const layers = editForm.getFieldValue(lK);
      const nDataLayers = layers.map((layer) => {
        const draggableId = get(layer, 'draggableId');
        if (draggableId === selectedLayer) {
          return { ...(layer || {}), ...(values || {}) };
        } else {
          return layer;
        }
      });
      editForm.setFieldsValue({ [lK]: nDataLayers });
      handleOnSetNewSelected();
    } else {
      handleOnSetNewSelected();
    }
  };

  const handleOnConfirm = () => {
    if (selectedLayer) {
      layerForm.validateFields().then((values) => {
        const d = editForm.getFieldValue();
        const layers = get(d, lK);
        const nDataLayers = layers.map((layer) => {
          const draggableId = get(layer, 'draggableId');
          if (draggableId === selectedLayer) {
            return { ...(layer || {}), ...(values || {}) };
          } else {
            return layer;
          }
        });
        let flag = false;
        nDataLayers.forEach((i) => {
          const res = validateLayerType(i, { breakpoint });
          if (!flag) {
            flag = get(res, 'hasError');
            //setSelectedLayer(get(i, 'draggableId'));
          }
        });
        //getI18nFromGeneral general.fixAllErr
        if (!flag) {
          editForm.validateFields().then((d) => {
            if (onConfirm) {
              onConfirm({ ...d, [lK]: nDataLayers });
            }
          });
        } else {
          msg.warning(getI18n('general.fixAllErr'));
        }
      });
    } else {
      editForm.validateFields().then((d) => {
        if (onConfirm) {
          onConfirm(d);
        }
      });
    }
  };

  return {
    handleOnLayerClick,
    selectedLayer,
    handleOnLayerAdd,
    handleOnLayerReorder,
    handleOnLayerDelete,
    handleOnConfirm,
  };
};
export { handleOnChange, useLayers };
